module.exports = __webpack_public_path__ + "img/expeditionary-stage_5.2.34cc7414.jpg";